// extracted by mini-css-extract-plugin
export default {"cover":"ModalOverlay_cover__HyUb+"};